import React from 'react';
import { DEFAULT_TIME_SLOTS, BREAK_INDEXES } from './subjectColor';

/**
 * Shared layout for Teacher & Class weekly grids.
 * Renders the Period/Time/Day header row and iterates rows with break dividers.
 * The cell renderer receives { day, period, pIdx } and returns JSX for the cell body.
 */
export const WeeklyGridShell = ({
  days,
  periods,
  renderCell,
  testId,
  rowTestIdPrefix = 'grid-row',
}) => (
  <div className="overflow-x-auto">
    <table className="w-full border-collapse" data-testid={testId}>
      <thead>
        <tr>
          <th className="p-2.5 text-left text-xs font-semibold text-slate-500 uppercase tracking-wider border-b-2 border-slate-300 w-20">Period</th>
          <th className="p-2.5 text-left text-xs font-semibold text-slate-500 uppercase tracking-wider border-b-2 border-slate-300 w-16">Time</th>
          {days.map(day => (
            <th key={day} className="p-2.5 text-center text-xs font-semibold text-slate-700 uppercase tracking-wider border-b-2 border-slate-300" style={{ minWidth: '160px' }}>{day}</th>
          ))}
        </tr>
      </thead>
      <tbody>
        {periods.map((period, pIdx) => {
          const timeSlot = DEFAULT_TIME_SLOTS[pIdx] || '';
          const breakLabel = BREAK_INDEXES[pIdx];
          return (
            <React.Fragment key={period}>
              {breakLabel && (
                <tr>
                  <td colSpan={2 + days.length} className="py-1">
                    <div className="h-px bg-slate-300 relative">
                      <span className="absolute left-1/2 -translate-x-1/2 -top-2.5 bg-white px-3 text-[10px] font-medium text-slate-400 uppercase tracking-wider">{breakLabel}</span>
                    </div>
                  </td>
                </tr>
              )}
              <tr className="group" data-testid={`${rowTestIdPrefix}-${pIdx + 1}`}>
                <td className="p-2 text-sm font-medium text-slate-600 border-b border-slate-100 whitespace-nowrap">{period}</td>
                <td className="p-2 text-xs text-slate-400 border-b border-slate-100 whitespace-nowrap">{timeSlot}</td>
                {days.map(day => renderCell({ day, period, pIdx }))}
              </tr>
            </React.Fragment>
          );
        })}
      </tbody>
    </table>
  </div>
);
